export const RESET_ALL_STORE = 'RESET_ALL_STORE';

export const resetAllStore = () => {
  return {
    type: RESET_ALL_STORE
  };
};
